import { begin, connect, freeze, snapshot, thaw } from "./endpoints";

export { basemapPaths, basemapRoutes } from "./paths";
export { BeginRoomRequest, RoomSnapshot, ThawRoomRequest } from "./schemas";
export {
  type ClientFrame,
  ClientFrameSchema,
  HEARTBEAT,
  HEARTBEAT_INTERVAL_MS,
  HEARTBEAT_SILENCE_MS,
  messagesOf,
  PartJoiner,
  type Peer,
  type Presence,
  ROOM_CLOSE,
  type ServerFrame,
  ServerFrameSchema,
  socketProtocol,
  type TakenCommit,
} from "./socket";

export const contract = { connect, begin, snapshot, freeze, thaw } as const;
